import { motion } from "framer-motion";

type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function PageHero({ eyebrow, title, description }: PageHeroProps) {
  return (
    <header className="relative overflow-hidden border-b border-white/10 pt-36">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_15%,rgba(30,109,255,0.3),transparent_32%),radial-gradient(circle_at_80%_10%,rgba(74,24,255,0.24),transparent_34%),linear-gradient(180deg,rgba(13,17,23,0.6),rgba(5,5,5,1))]" />
      <div className="container relative z-10 pb-20 pt-10 sm:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, ease: "easeOut" }}
          className="max-w-4xl"
        >
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="max-w-4xl font-display text-4xl font-semibold leading-tight text-white sm:text-6xl">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-white/70">
            {description}
          </p>
        </motion.div>
      </div>
    </header>
  );
}
